import { useMemo } from 'react';
import ConversationMessage from '@/components/chat/ConversationMessage';

interface Message {
  text: string;
  role: string;
  created_at: string;
  _id?: string;
  data?: { url: string; type: string; transcription_text?: string }[] | null;
}

interface ConversationChatProps {
  messages?: Message[];
  className?: string;
  highlightMessageId?: string;
}

export default function ConversationChat({
  messages = [],
  className = '',
  highlightMessageId,
}: ConversationChatProps) {
  // Generate stable IDs for messages that don't have them, filter system messages
  const messagesWithIds = useMemo(() => {
    return messages
      .filter((message) => message.role !== 'system')
      .map((message) => {
        if (!message._id) {
          return {
            ...message,
            _id: crypto.randomUUID(),
          };
        }
        return message;
      });
  }, [messages]);

  return (
    <div
      className={`relative flex w-full overflow-hidden border rounded-xl shadow-sm border-neutral-200 ${className}`}
    >
      <div className="flex flex-col w-full h-full p-3 bg-white">
        <div className="relative flex flex-col w-full h-full px-2 overflow-hidden overflow-y-auto">
          <div className="flex flex-col w-full gap-1 pb-2 mt-8">
            {messagesWithIds.map((message) => {
              const messageKey = message._id;
              return (
                <ConversationMessage
                  key={messageKey}
                  {...message}
                  _id={message._id!}
                  isHighlighted={message._id === highlightMessageId}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
